export default __webpack_public_path__ + "assets/models/b0492918faf3deeecb3d6a43ad5e022f.glb";